import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6211f698"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6211f698')) {
      api.createRecord('6211f698', component.options)
    } else {
      api.reload('6211f698', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6211f698", function () {
      api.rerender('6211f698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/teacher/Index.vue"
export default component.exports